import { type ElementStyles, css } from '@microsoft/fast-element';
import type { HoverIconDefinition, HoverIcon } from './HoverIcon';
import { archive } from 'owa-locstrings/lib/strings/archive.locstring.json';
import { archiveRow } from 'owa-mail-list-item-shared';
import { startAnimationOrHandleActionAsNeeded } from 'owa-mail-list-item-animation-store';
import { ArchiveFilled, ArchiveRegular } from '@fluentui/react-icons/fonts';

const ArchiveRegularFontGlyph = ArchiveRegular.codepoint;
const ArchiveFilledFontGlyph = ArchiveFilled.codepoint;

const BaseArchiveIconStyles: ElementStyles = css`
    .icon:before {
        color: var(--colorNeutralForeground3);
        content: '${ArchiveRegularFontGlyph}';
    }

    :host(:hover) .icon:before,
    :host(:active) .icon:before {
        color: var(--colorStatusSuccessForeground1);
        content: '${ArchiveFilledFontGlyph}';
    }
`;

export const Archive: HoverIconDefinition = {
    title(this: Readonly<HoverIcon>) {
        return archive;
    },
    customCss: BaseArchiveIconStyles,
    onClick(this: HoverIcon) {
        const handleArchive = () => {
            archiveRow(this.rowKey, this.tableViewId, 'Hover');
        };
        startAnimationOrHandleActionAsNeeded(
            'Archive',
            [this.rowKey],
            'Hover',
            false /*isActionTakenFromDialog*/,
            handleArchive
        );
    },
};
